import { Skeleton } from "antd";

export default function VideoContentLoading() {
  return (
    <section>
      <Skeleton.Input active className="!h-8 !w-64 mb-6" />
      <Skeleton.Image active className="!w-full !h-[350px]" />
    </section>
  );
}
